import { ChevronRight } from 'lucide-react';
import { DevToolsDirectionBadge } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsDirectionBadge';
import { DevToolsStatusBadge } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge';
import type { DebugLegRowProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugLegRow/index.types';
import { useDebugContact } from 'Modules/softphone/components/SoftphoneDevTools/hooks';
import {
  formatCallDuration,
  getLegHealth,
} from 'Modules/softphone/components/SoftphoneDevTools/utils';
import React from 'react';

/**
 * DebugLegRow - One captured leg, as a line in the history
 *
 * The row answers only what the list is scanned for:
 */
export const DebugLegRow: React.FC<DebugLegRowProps> = ({ info, onOpen }) => {
  const { displayName } = useDebugContact(info.phoneNumber);
  const health = getLegHealth(info);
  const duration = formatCallDuration(info.startTime, info.endTime);

  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex w-full items-center gap-2.5 border-b border-zinc-800 px-3 py-[11px] text-left transition-colors hover:bg-zinc-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-emerald-400/40"
    >
      <DevToolsDirectionBadge direction={info.direction} compact />

      <span className="min-w-0 flex-1">
        <span className="block truncate text-[12.5px] font-semibold text-zinc-200">
          {displayName}
        </span>
        <span className="block truncate font-sp-mono text-[10.5px] text-zinc-400">
          {info.callId}
        </span>
      </span>

      <span className="flex flex-shrink-0 flex-col items-end gap-[3px]">
        <DevToolsStatusBadge label={health.label} variant={health.variant} />
        {duration && (
          <span className="font-sp-mono text-[10.5px] text-zinc-400">
            {duration}
          </span>
        )}
      </span>

      <ChevronRight className="h-3.5 w-3.5 flex-shrink-0 text-zinc-400" />
    </button>
  );
};
